/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('faq.color-palette', function (el) {
        var component = new ColorPalette(el);
        component.run();
    });
    var ColorPalette = /** @class */ (function () {
        function ColorPalette(element) {
            this.element = element;
        }
        ColorPalette.prototype.run = function () {
            var _this = this;
            var _a;
            this.element.style.display = 'none';
            // 2. Búa til wrapper fyrir litabólurnar
            var wrapper = document.createElement('div');
            wrapper.className = 'color-palette-wrapper';
            wrapper.style.display = 'flex';
            wrapper.style.gap = '10px';
            wrapper.style.flexWrap = 'wrap';
            (_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapper, this.element.nextSibling);
            Array.from(this.element.options).forEach(function (option) {
                if (!option.value)
                    return;
                var swatch = document.createElement('button');
                swatch.type = 'button';
                swatch.title = option.text;
                swatch.style.backgroundColor = option.value;
                swatch.style.width = '40px';
                swatch.style.height = '40px';
                swatch.style.borderRadius = '50%';
                swatch.style.border = '2px solid transparent';
                swatch.style.cursor = 'pointer';
                if (_this.element.value === option.value) {
                    swatch.style.border = '2px solid #000';
                }
                swatch.addEventListener('click', function () {
                    _this.element.value = option.value;
                    // Hreinsa border af öllum og merkja svo þann valda
                    Array.from(wrapper.children).forEach(function (child) {
                        child.style.border = '2px solid transparent';
                    });
                    swatch.style.border = '2px solid #000';
                });
                wrapper.appendChild(swatch);
            });
        };
        return ColorPalette;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
